import {
  lesson9Assignment1,
} from './assignments';
import { createChessboard } from '../../utils'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 1,
    video: {
      src: 'img/videos/lesson_9/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    audio: { src: 'img/audio/lesson_9/1.mp3', start: true, controls: false },
    directions: {
      timeout: 0,
      data: `<b>ANALYSIS :</b> <br/>Here are four <br/>options for the <br/>Knight on f3. <br/>Click on the <br/>best option.`,
      className: 'no-animation'
    },
    options: {
      answer: [
        'Knight captures e5 Rook',
        'Knight captures d4 Bishop',
        'Knight moves to d2',
        'Knight moves to e1'
      ],
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      magnusCorrectAnswer: {
        data: 'Correct, White would win the Bishop worth 3 points.',
        styleClass: 'md',
        waitTime: 6000
      },
      magnusWrongAnswer: {
        data: 'Oops! The best choice is to safely capture the Bishop, worth 3 points, and not risk being captured.',
        styleClass: 'xl',
        waitTime: 7000
      }
    },
    chessboard: {
      board: lesson9Assignment1({
        showIndicators: { allSides: true },
        position: 'r5k1/pb3ppp/1pp5/3pr3/3b3B/2NP1N2/PPP2PPP/R4RK1',
        assignmentClass: 'custom-sparepiece',
        next: 2
      }),
      canvas: true
    }
  },

  {
    id: 2,
    previous: 1,
    next: 3,
    video: {
      src: 'img/videos/lesson_9/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    audio: { src: 'img/audio/lesson_9/2 .mp3', start: true, controls: false },
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It's Black's turn <br/>to move.<br/>Click on the <br/>correct answer.`,
      className: 'no-animation'
    },
    options: {
      answer: [
        'CHECKMATE',
        'STALEMATE',
        'PLAY ON!'
      ],
      magnusWrongAnswer: {
        data: 'Oops! This is a Stalemate. The King is not in check but there is no legal move to make.',
        styleClass: 'xl',
        waitTime: 8000
      },
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: '7k/6rP/5BB1/8/8/8/1K6/8',
        assignmentClass: 'custom-sparepiece',
        next: 4
      }),
    }
  },
  {
    id: 4,
    previous: 3,
    next: 5,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It's Black's turn <br/>to move.<br/>Click on the <br/>correct answer.`,
      className: 'no-animation'
    },
    options: {
      answer: [
        'CHECKMATE',
        'STALEMATE',
        'PLAY ON!'
      ],
      magnusWrongAnswer: {
        data: 'Oops! It’s Play On! The King is not in check, and there are several moves that can be made.',
        styleClass: 'xxl',
        waitTime: 8000
      },
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: '7k/1p5P/p6K/P2p4/3P4/8/8/8',
        assignmentClass: 'custom-sparepiece',
        next: 5
      }),
    }
  },
  {
    id: 5,
    previous: 4,
    next: 6,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It's Black's turn <br/>to move.<br/>Click on the <br/>correct answer.`,
      className: 'no-animation'
    },
    options: {
      answer: [
        'CHECKMATE',
        'STALEMATE',
        'PLAY ON!'
      ],
      magnusWrongAnswer: {
        data: 'Oops! It’s checkmate. The white pawn is attacking the Black King and there is no way to capture, block or escape.',
        styleClass: 'xxxl',
        waitTime: 8000
      },
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: '2R3qk/1p4P1/p6K/P2p4/3P4/8/8/2R5',
        assignmentClass: 'custom-sparepiece',
        next: 6
      }),
    }
  },
  {
    id: 6,
    previous: 5,
    next: 7,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It's Black's turn <br/>to move.<br/>Click on the <br/>correct answer.`,
      className: 'no-animation'
    },
    options: {
      answer: [
        'CHECKMATE',
        'STALEMATE',
        'PLAY ON!'
      ],
      magnusWrongAnswer: {
        data: "Oops! It's a Play On! The Rook has the King in check, but the black Bishop can move to c8 to block the attack.",
        styleClass: 'xl',
        waitTime: 8000
      },
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: '1k3R2/1pp5/pP6/8/4P3/4P2b/1K6/8',
        assignmentClass: 'custom-sparepiece',
        next: 7
      }),
    }
  },
  {
    id: 7,
    previous: 6,
    next: 8,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It's Black's turn <br/>to move.<br/>Click on the <br/>correct answer.`,
      className: 'no-animation'
    },
    options: {
      answer: [
        'CHECKMATE',
        'STALEMATE',
        'PLAY ON!'
      ],
      magnusWrongAnswer: {
        data: "Oops! It's checkmate. The white Bishop and Rook have the black King in checkmate, there is no way to capture, block or escape.",
        styleClass: 'xxxl',
        waitTime: 8000
      },
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: '2r1R2k/1p1b1p1p/p5p1/8/8/2B3P1/1PP2P1P/6K1',
        assignmentClass: 'custom-sparepiece',
        next: 8
      }),
    }
  },
  {
    id: 8,
    previous: 7,
    next: 9,
    directions: {
      timeout: 0,
      data: `<b>DIRECTIONS:</b> <br/>Analyze the <br/>board to <br/>determine if it is <br/>checkmate, <br/>stalemate <br/>or play on!<br/>It's Black's turn <br/>to move.<br/>Click on the <br/>correct answer.`,
      className: 'no-animation'
    },
    options: {
      answer: [
        'CHECKMATE',
        'STALEMATE',
        'PLAY ON!'
      ],
      magnusWrongAnswer: {
        data: "Oops, it’s a stalemate. The King is not in check, but the Knight and pawn are attacking every square the King could move to.",
        styleClass: 'xxxl',
        waitTime: 8000
      },
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
    },
    chessboard: {
      board: createChessboard({
        showIndicators: { allSides: true },
        position: '7k/8/5N1P/8/3K4/8/8/8',
        assignmentClass: 'custom-sparepiece',
        next: 9
      }),
    }
  },
  {
    id: 9,
    previous: 8,
    next: 10,
    video: {
      src: 'img/videos/lesson_9/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 10,
    }
  },
  {
    id: 10,
    previous: 9,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: "If a King is in check and there is no way to capture or block the attacking piece, and no way for the King to escape, it's called...",
      answer: [
        "Scholar's Mate",
        'Checkmate',
        'Stalemate',
        "Fool's Mate"

      ],
      rightAnswer: 'Checkmate',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 9,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: "What is 'Check'?",
      answer: [
        'When the King is under attack',
        'When the King is captured',
        'When the Queen is under attack',
        'When the Queen is captured'
      ],
      rightAnswer: 'When the King is under attack',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 9,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: "What is Fool's Mate?",
      answer: [
        'When you accidentally checkmate the King',
        'The slowest checkmate possible',
        'The fastest checkmate possible',
        'Not really a checkmate'
      ],
      rightAnswer: 'The fastest checkmate possible',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 13,
    previous: 9,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: "What is Stalemate?",
      answer: [
        'When you accidentally checkmate the King',
        'The slowest checkmate possible',
        "When a player cannot move but isn't in check",
        'A King without any pieces to help'
      ],
      rightAnswer: "When a player cannot move but isn't in check",
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md',
      rightAnswerTimeout: 7000
    }
  },
  {
    id: 14,
    previous: 9,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'Analyze the game; what is happening?',
      answer: [
        'White is checkmated',
        'Black is checkmated',
        'It is a stalemate',
        'They should play on'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'rrk5/ppp5/8/8/2p4B/1Q4PB/2p2P2/K7'
        }),
        hint: true
      },
      rightAnswer: 'Black is checkmated',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 9,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'Analyze the game; what is happening?',
      answer: [
        'White is checkmated',
        'Black is checkmated',
        'It is a stalemate',
        'They should play on'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'rn1qkb1r/pp1bpp1p/3p1Np1/1Bn5/3N4/8/PPP1QPPP/R1B1K2R'
        }),
        hint: true
      },
      rightAnswer: 'Black is checkmated',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 16,
    previous: 9,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'Queen to c7 is a bad move. Why?',
      answer: [
        'The Black King can capture the White Queen',
        'It causes stalemate',
        'The White King should move first',
        "It's check, not checkmate"
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: 'k7/7Q/8/8/1K6/8/8/8'
        }),
        hint: true,
        canvas: {
          from: "square-h7",
          to: "square-c7"
        }
      },
      rightAnswer: 'It causes stalemate',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 17,
    previous: 9,
    next: 18,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'Black Queen to c2 a good idea. Why?',
      answer: [
        'It is trapping the White King',
        'It creates a stalemate',
        'It creates a checkmate',
        'There are no other options'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/8/8/8/8/3q2k1/8/4K3'
        }),
        hint: true,
        canvas: {
          from: "square-d3",
          to: "square-c2"
        }
      },
      rightAnswer: 'It is trapping the White King',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'lg'
    }
  },
  {
    id: 18,
    previous: 9,
    next: 19,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'Which of these squares can Black move to checkmate White?',
      answer: [
        'Queen to c4',
        'Queen to g2',
        'Queen to f5',
        'Queen to d1'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '8/8/8/8/8/6k1/2q5/5K2'
        }),
        hint: true
      },
      rightAnswer: 'Queen to d1',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 19,
    previous: 9,
    next: 20,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'Which of these squares can White move to checkmate Black?',
      answer: [
        'Bishop to g8',
        'King to g6',
        'Bishop to e5',
        'Bishop to b8'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
          position: '7k/5B2/7K/8/8/8/7B/8'
        }),
        hint: true
      },
      rightAnswer: 'Bishop to e5',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 20,
    previous: 9,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Ten',
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_8.png',
  '/img/background_9.png',
  '/img/background_10.png'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_9/index.js